import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GlobalModule } from 'src/app/global/global.module';
import { AcompanhamentoSobraComponent } from './acompanhamento-sobra-main/acompanhamento-sobra.component';

@NgModule({
    declarations: [AcompanhamentoSobraComponent],
    imports: [CommonModule, GlobalModule]
})
export class AcompanhamentoSobraModule { }